exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".max-width {\n  width: 100px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/listado-marcas/listado-marcas.component.css
// module id = ../../../../../src/app/pages/admin/listado-marcas/listado-marcas.component.css
// module chunks = main